import { useId } from "react";
import {
  GardenGround,
  RAIN_STREAKS,
  SkySvgShell,
  VIEW_HEIGHT,
  VIEW_WIDTH,
} from "@/app/components/weather/backgrounds/shared";

/**
 * RainyDaySky — deeper blue-gray day sky with cloud cover and rain streaks.
 * Full-viewport illustration; garden silhouettes anchor to the bottom edge.
 */
export function RainyDaySky() {
  const uid = useId().replace(/:/g, "");
  const sky = `${uid}-sky`;
  const haze = `${uid}-haze`;
  const rain = `${uid}-rain`;

  return (
    <SkySvgShell>
      <defs>
        <linearGradient id={sky} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#5A7898" />
          <stop offset="35%" stopColor="#7088A8" />
          <stop offset="70%" stopColor="#90A8C0" />
          <stop offset="100%" stopColor="#B0C4D8" />
        </linearGradient>
        <linearGradient id={haze} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#90A8C0" stopOpacity="0" />
          <stop offset="100%" stopColor="#8098B0" stopOpacity="0.85" />
        </linearGradient>
        <linearGradient id={rain} x1="0" y1="0" x2="0.05" y2="1">
          <stop offset="0%" stopColor="#6888A8" stopOpacity="0" />
          <stop offset="40%" stopColor="#6888A8" stopOpacity="0.35" />
          <stop offset="100%" stopColor="#6888A8" stopOpacity="0" />
        </linearGradient>
      </defs>

      <rect width={VIEW_WIDTH} height={VIEW_HEIGHT} fill={`url(#${sky})`} />

      <g fill="#C8D4E0" opacity="0.75">
        <ellipse cx="62" cy="55" rx="72" ry="26" />
        <ellipse cx="28" cy="50" rx="38" ry="20" />
        <ellipse cx="108" cy="50" rx="44" ry="21" />
        <ellipse cx="338" cy="58" rx="64" ry="24" />
        <ellipse cx="304" cy="52" rx="38" ry="19" />
      </g>

      <g fill="#B8C8D8" opacity="0.85">
        <ellipse cx="80" cy="88" rx="80" ry="30" />
        <ellipse cx="36" cy="82" rx="44" ry="22" />
        <ellipse cx="132" cy="82" rx="52" ry="24" />
        <ellipse cx="220" cy="96" rx="68" ry="27" />
        <ellipse cx="340" cy="90" rx="72" ry="28" />
        <ellipse cx="298" cy="83" rx="46" ry="22" />
      </g>

      <g fill="#A8B8C8" opacity="0.9">
        <ellipse cx="100" cy="122" rx="96" ry="36" />
        <ellipse cx="44" cy="114" rx="54" ry="28" />
        <ellipse cx="264" cy="118" rx="90" ry="34" />
        <ellipse cx="320" cy="110" rx="56" ry="26" />
        <ellipse cx="370" cy="128" rx="52" ry="30" />
      </g>

      <rect x="0" y="140" width={VIEW_WIDTH} height={VIEW_HEIGHT - 140} fill={`url(#${rain})`} opacity="0.5" />
      {RAIN_STREAKS.map(([x, y, h], i) => (
        <line
          key={i}
          x1={x + 2}
          y1={y}
          x2={x}
          y2={y + h}
          stroke="#5878A0"
          strokeWidth="0.7"
          opacity="0.45"
        />
      ))}

      <rect x="0" y="200" width={VIEW_WIDTH} height={VIEW_HEIGHT - 200} fill={`url(#${haze})`} />

      <GardenGround fill="#142030" />
    </SkySvgShell>
  );
}
